(() => {
  function init(root) {
    root.querySelectorAll('[data-kare-special]').forEach((section) => {
      if (section.dataset.specialReady) return;
      const select = section.querySelector('[data-special-variant]');
      const price = section.querySelector('[data-special-price]');
      const button = section.querySelector('[data-special-submit]');
      const status = section.querySelector('[data-special-status]');
      if (!select) return;

      const refresh = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        price.textContent = option.dataset.price || '';
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableText : 'Sold out';
        status.textContent = available ? 'Available to order' : 'Currently unavailable';
      };

      select.addEventListener('change', refresh);
      refresh();
      section.dataset.specialReady = 'true';
    });
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
